import { render } from "./BrowseFile.vue?vue&type=template&id=1af2ebd5&scoped=true"
import script from "./BrowseFile.vue?vue&type=script&lang=js"
export * from "./BrowseFile.vue?vue&type=script&lang=js"

import "./BrowseFile.vue?vue&type=style&index=0&id=1af2ebd5&scoped=true&lang=css"
import "./BrowseFile.vue?vue&type=style&index=1&id=1af2ebd5&lang=scss"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af2ebd5"]])

export default __exports__